















































import * as firebaseui from 'firebaseui'


export default
  data: ->
    user: null
    fUser: null
    dropdown: false
    nickChange: false
    newNick: null
    visible: false

  computed:
    loggedIn: -> @user?

  created: ->
    window.authui or= new firebaseui.auth.AuthUI(firebase.auth())
    firebase.auth().onAuthStateChanged (@fUser) =>
      if @fUser
        { displayName } = @fUser
        @user = { displayName }
        @$emit (@fUser? and 'logged-in' or 'logged-out'), @fUser?.toJSON()
        @newNick = displayName
      else
        @user = null
        @$emit 'logged-out'
        @showUi() if not @fUser?

  methods:
    showUi: ->
      authConfig =
        signInFlow: 'popup'
        callbacks: signInSuccessWithAuthResult: (user) -> false
        credentialHelper: firebaseui.auth.CredentialHelper.NONE
        signInSuccessUrl: '/'
        signInOptions: [
          firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          # firebase.auth.FacebookAuthProvider.PROVIDER_ID,
          firebase.auth.GithubAuthProvider.PROVIDER_ID,
          firebase.auth.EmailAuthProvider.PROVIDER_ID
        ]
        # tosUrl: '/tos.html'
      authui.start('#auth-container', authConfig)

    signOut: ->
      firebase.auth().signOut()
      @visible = false

    changeName: ->
      await @fUser.updateProfile displayName: @newNick
      @user.displayName = @newNick
      @nickChange = false
      @$emit 'name-changed', @newNick

    toggleDropdown: ->
      @dropdown = not @dropdown
      if not @dropdown
        @nickChange = false

